module.exports = __webpack_public_path__ + "static/cljs-0985f8933d40e931f414cb986914c873.png";